export default "__VITE_ASSET__BC1Y5RDv__"